export var apiPromises = {
  idv: undefined
};